import { useAuth } from 'react-oidc-context';

import { expandClaimToArray, getUsername } from '@/app/auth/claims';
import { DevNavTabs } from './DevNavTabs';

function toClaimEntries(profile: Record<string, unknown> | undefined): { type: string; value: string }[] {
  return Object.entries(profile ?? {}).flatMap(([type, raw]) =>
    expandClaimToArray(raw).map((value) => ({ type, value })),
  );
}

export function DevAuthenticationPage() {
  const auth = useAuth();
  const user = auth.user;

  return (
    <>
      <DevNavTabs />

      <div className="m-3">
        {auth.isAuthenticated && user ? (
          <>
            Logged user: {getUsername(user)}

            <div className="mt-3">
              <div className="list-group">
                {toClaimEntries(user.profile).map((claim, index) => (
                  <div className="list-group-item" key={`${claim.type}-${index}`}>
                    {claim.type} : {claim.value}
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-3">
              {user.access_token ? (
                <>
                  <h2 className="mb-0">Access Token</h2>
                  <dl className="mt-2">
                    <dt>Scopes</dt>
                    <dd>{(user.scope ?? '').split(' ').filter(Boolean).join(', ')}</dd>
                  </dl>
                </>
              ) : (
                <div>Access token not found</div>
              )}
            </div>
          </>
        ) : (
          <>
            User not logged in
            <a href="authentication/login">Log in</a>
          </>
        )}
      </div>
    </>
  );
}
